module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-01.a6597ce6.png";